import axios from 'axios';
import conf from '../conf/conf';
 
// Встановлюємо базовий шлях до АРІ
const axiosServices = axios.create({ baseURL: conf.apiAdmin, withCredentials: true });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //
 
axiosServices.interceptors.request.use(
    async (config) => {
        /*
        const accessToken = localStorage.getItem('serviceToken');
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
            */
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
 
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log('axios error:', error);
        if (error.response?.status === 401 && !window.location.href.includes('/login')) {
            window.location.pathname = '/maintenance/500';
        }

        if (error.response?.status === 403 && !window.location.href.includes('/login')) {
            window.location.pathname = '/login';
        }

        return Promise.reject((error.response?.data) || 'Wrong Services');
    }
);

export default axiosServices;

export const fetcher = async (args) => {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosServices.get(url, { ...config });

    return res.data;
};

export const fetcherPost = async (args) => {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosServices.post(url, { ...config });

    return res.data;
};
